module.exports = __webpack_public_path__ + "img/20240531_3.7cffac42.jpg";